import { createAction, props } from '@ngrx/store';

import { Category } from '@core/models/category.model';

export const categoriesNestedCollectionAddMany = createAction(
  '[STORED CATEGORIES NESTED - ADD MANY] Categories Nested collection add many.',
  props<{ categoriesNested: Category[] }>()
);
